import type { RouteLocationGeneric, RouteLocationRaw, RouteRecordRaw } from 'vue-router'

import { CREATIVE_AI_ROUTE } from '@/features/creative-ai'

export const LEGACY_CREATIVE_AI_LANDING_PATH =
  '/accounts/:account_id/workspaces/:workspace_id/creative-performance/creative-analysis'

function routeParam(value: string | string[] | undefined): string {
  return Array.isArray(value) ? (value[0] ?? '') : (value ?? '')
}

/**
 * v3's account/workspace-qualified Creative Analysis URL was a landing entry, not a detail URL.
 * Carry every query key through the redirect, but let the path remain authoritative for context.
 */
export function creativeAiLandingIngressRedirect(to: RouteLocationGeneric): RouteLocationRaw {
  return {
    name: CREATIVE_AI_ROUTE.name,
    // A named target has no path params. Do not let Vue Router inherit the legacy context params.
    params: {},
    query: {
      ...to.query,
      account_id: routeParam(to.params.account_id),
      workspace_id: routeParam(to.params.workspace_id),
    },
  }
}

/**
 * This must stay above the catch-all. The target is registered through the feature public barrel;
 * the historical `/creative-ai/:analysisId/:tab?` detail ingress remains owned by ORP-18906.
 */
export const creativeAiLandingIngressRoutes: RouteRecordRaw[] = [
  {
    path: LEGACY_CREATIVE_AI_LANDING_PATH,
    name: 'CreativeAiLegacyLandingIngress',
    redirect: creativeAiLandingIngressRedirect,
  },
]
